/** Mirrors the server's buildJobDetailPath / parseJobIdFromSegment contract. */
export const landingJobId = (path: string | null): string | null => {
  const segment = /^\/job-listings\/job\/([\da-z]+(?:-[\da-z]+)*)$/.exec(path ?? "")?.[1];
  if (!segment) return null;
  return segment.slice(segment.lastIndexOf("-") + 1);
};
